<template>
  <div>
    <div @click="dialog = true" v-if="btn !== false">
      <slot />
    </div>

    <v-dialog
      v-model="dialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
      persistent
    >
      <v-card>
        <v-toolbar color="primary" dark fixed class="sticky-top">
          <v-toolbar-title>
            <v-icon>mdi-car</v-icon>
            {{ $i18n.t("Select Invoice(s)") }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn icon @click="dialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>

        <v-card-text>
          <v-row>
            <v-col cols="12" md="2" sm="4">
              <v-text-field
                :label="$i18n.t('Invoice No')"
                class="purple-input"
                v-model="filter.invoiceNo"
              />
            </v-col>
            <v-col cols="12" md="2" sm="4">
              <v-select
                :label="$i18n.t('Status')"
                class="purple-input"
                v-model="filter.status"
                :items="statusList"
              />
            </v-col>
            <v-col cols="12" sm="12" md="4" lg="3">
              <z-date-picker
                :label="$i18n.t('From Date')"
                v-model="filter.fromDate"
              />
            </v-col>
            <v-col cols="12" sm="12" md="4" lg="3">
              <z-date-picker
                :label="$i18n.t('Till Date')"
                v-model="filter.toDate"
              />
            </v-col>

            <v-spacer />
            <v-col cols="12" md="2" sm="4" class="text-right pull-right my-3">
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn
                    class="mr-0"
                    color="black"
                    text
                    fab
                    x-small
                    @click="clearSearch()"
                    style="margin-right: 2px !important"
                    v-on="on"
                  >
                    <v-icon>mdi-cached</v-icon>
                  </v-btn>
                </template>
                <span>{{ $i18n.t("Clear Filter") }}</span>
              </v-tooltip>
              <v-btn
                color="success"
                class="mr-0"
                fab
                x-small
                dark
                @click="search()"
                :loading="loading"
              >
                <v-icon>mdi-magnify</v-icon>
              </v-btn>
              <v-btn @click="proccedWithCehcked">Select</v-btn>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-text>
          <v-btn
            v-if="grid != undefined && !grid.records"
            class="text-center secondary--text pa-10"
            text
            color="primary"
            style="width: 100%"
            :loading="loading"
            >{{ $i18n.t("No records available") }}</v-btn
          >
          <v-row>
            <v-col cols="12" md="12" sm="12">
              <v-simple-table dense v-if="grid.records">
                <thead>
                  <tr>
                    <th class="primary--text">
                      <v-checkbox v-model="selectAll" />
                    </th>
                    <th class="primary--text">{{ $i18n.t("Invoice No") }}</th>
                    <th class="primary--text">{{ $i18n.t("Date") }}</th>
                    <th class="primary--text">{{ $i18n.t("Created By") }}</th>
                    <th class="primary--text">{{ $i18n.t("Client") }}</th>
                    <th class="primary--text">{{ $i18n.t("Status") }}</th>
                    <th class="primary--text text-center">
                      {{ $i18n.t("Outstanding") }}
                    </th>
                  </tr>
                </thead>

                <tbody>
                  <tr v-for="vehicle in grid.rows" :key="vehicle._id">
                    <td>
                      <v-checkbox v-model="vehicle.selected" />
                    </td>
                    <td>{{ vehicle.invoiceNo }}</td>
                    <td>{{ formatDate(vehicle.invoiceDate) }}</td>
                    <td>{{ vehicle.createdByName }}</td>
                    <td>{{ vehicle.clientName }}</td>
                    <td>{{ vehicle.invoiceStatus }}</td>
                    <td class="text-right">{{ vehicle.toBeCollected }}</td>
                  </tr>
                </tbody>
              </v-simple-table>
              <v-pagination
                v-if="grid.records"
                v-model="grid.page"
                class="my-4"
                :length="grid.total"
                total-visible="10"
                @input="showPage"
              ></v-pagination>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { doPost } from "@/store/common/module/apis";
import common from "@/store/common/module/common";
import Themeable from "vuetify/lib/mixins/themeable";
import { Vue, Component, Watch } from "vue-property-decorator";

@Component({
  name: "InvoiceSelect",
  props: {
    corp_id: {
      default: null,
    },
    client_id: {
      default: null,
    },
    supplier_id: {
      default: null,
    },
    value: {
      default: null,
    },
    idOnly: {
      default: false,
    },
    disabled: {
      default: false,
    },
    label: {
      default: "Invoice",
    },
    multiple: {
      default: false,
    },
    clearable: {
      default: false,
    },
    btn: {
      default: false,
    },
    prependIcon: {
      default: undefined,
    },
    prependInnerIcon: {
      default: undefined,
    },
    invoices: {
      default: undefined,
    },
    rules: {
      default: () => [],
    },
    statuses: {
      default: null,
    },
    selectedInvoices: {
      default: null,
    },
  },
})
export default class InvoiceSelect extends (Vue, Themeable) {
  grid = {};
  rows = 20;
  url = "/api/invoice/grid/all/post?rows=";
  filter = {
    invoiceNo: null,
    status: null,
    fromDate: null,
    toDate: null,
    client_id: null,
    clientEntity_id: null,
    shippingEntity_id: null,
    supplier_id: null,
    regNo: null,
    driverName: null,
    driverCC: null,
    driverPhone: null,
  };
  selectAll = false;
  on = null;
  page = 1;
  dialog = false;
  loading = false;
  statusList = [];

  @Watch("selectAll")
  onSelectAll() {
    if (this.grid && this.grid.rows) {
      for (let i = 0; i < this.grid.rows.length; i++) {
        this.grid.rows[i].selected = this.selectAll;
      }
    }
  }

  proccedWithCehcked() {
    const callback = [];
    if (this.grid && this.grid.rows) {
      for (let i = 0; i < this.grid.rows.length; i++) {
        if (this.grid.rows[i].selected) {
          const data = this.grid.rows[i];
          callback.push(data);
        }
      }
    }
    this.$emit("selectedInvoices", callback);
    this.dialog = false;
  }

  async mounted() {
    this.filter = {
      invoiceNo: null,
      status: null,
      fromDate: null,
      toDate: null,
      client_id: null,
      clientEntity_id: null,
      shippingEntity_id: null,
      supplier_id: null,
      regNo: null,
      driverName: null,
      driverCC: null,
      driverPhone: null,
    };
  }

  async showPage(page) {
    this.page = page;
    const filt = this.statuses ? "&statuses=" + this.statuses : "";
    this.loading = true;
    this.grid = {};
    try {
      const data = await doPost(
        this.url + this.rows + filt + this.filterUrl + "&page=" + page,
        { notinvalues: this.invoices }
      );

      for (let i = 0; i < data.rows.length; i++) {
        data.rows[i].selected = false;
      }
      this.grid = data;
      this.loading = false;
    } catch (e) {
      this.loading = false;
      common.showError(e.message);
    }
  }

  async clearSearch() {
    this.filter = {
      invoiceNo: null,
      status: null,
      fromDate: null,
      toDate: null,
      client_id: null,
      clientEntity_id: null,
      shippingEntity_id: null,
      supplier_id: null,
      regNo: null,
      driverName: null,
      driverCC: null,
      driverPhone: null,
    };
    this.page = 1;
    this.search();
  }

  async search() {
    this.filter.vendor_id = this.supplier_id;
    this.filter.client_id = this.client_id;
    let filterUrl = "";
    if (this.filter.fromDate) filterUrl += "&fromDate=" + this.filter.fromDate;
    if (this.filter.toDate) filterUrl += "&toDate=" + this.filter.toDate;
    if (this.filter.invoiceNo)
      filterUrl += "&invoiceNo=" + this.filter.invoiceNo;
    if (this.filter.status) filterUrl += "&status=" + this.filter.status;
    if (this.filter.client_id)
      filterUrl += "&client_id=" + this.filter.client_id;
    if (this.filter.vendor_id)
      filterUrl += "&vendor_id=" + this.filter.vendor_id;
    if (this.filter.clientEntity_id)
      filterUrl += "&clientEntity._id=" + this.filter.clientEntity_id;
    if (this.filter.shippingEntity_id)
      filterUrl += "&shippedToEntity._id=" + this.filter.shippingEntity_id;
    if (this.filter.supplier_id)
      filterUrl += "&supplier_id=" + this.filter.supplier_id;
    if (this.filter.regNo) filterUrl += "&regNo=" + this.filter.regNo;
    if (this.filter.driverName)
      filterUrl += "&driverName=" + this.filter.driverName;
    if (this.filter.driverCC) filterUrl += "&driverCC=" + this.filter.driverCC;
    if (this.filter.driverPhone)
      filterUrl += "&driverPhone=" + this.filter.driverPhone;

    this.filterUrl = filterUrl;
    await this.showPage(1);
  }

  setStatusList() {
    this.statusList = [];
    if (this.statuses) {
      if (this.statuses.indexOf("0") != -1)
        this.statusList.push({ value: 0, text: "Created" });
      if (this.statuses.indexOf("1") != -1)
        this.statusList.push({ value: 1, text: "Verified" });
      if (this.statuses.indexOf("2") != -1)
        this.statusList.push({ value: 2, text: "Submitted" });
      if (this.statuses.indexOf("3") != -1)
        this.statusList.push({ value: 3, text: "Payment Collected" });
      if (this.statuses.indexOf("4") != -1)
        this.statusList.push({ value: 4, text: "Rejected" });
      if (this.statuses.indexOf("5") != -1)
        this.statusList.push({ value: 5, text: "Partially Paid" });
    } else {
      this.statusList = [
        { value: 0, text: "Created" },
        { value: 1, text: "Verified" },
        { value: 2, text: "Submitted" },
        { value: 3, text: "Payment Collected" },
        { value: 4, text: "Rejected" },
        { value: 5, text: "Partially Paid" },
      ];
    }
  }

  @Watch("dialog")
  async onDialogChange(val) {
    if (val) {
      try {
        this.setStatusList();
        this.search();
      } catch (e) {
        common.setError(e.message);
      }
    }
  }

  formatDate(date) {
    if (date) {
      const dateStr = date.toString();
      return (
        dateStr.substring(6, 8) +
        "-" +
        dateStr.substring(4, 6) +
        "-" +
        dateStr.substring(0, 4)
      );
    } else {
      return "";
    }
  }
}
</script>

<style scoped>
.pac-target-input {
  width: 50%;
  border: 1px solid #dfdfdf;
  height: 30px;
  padding: 10px 20px;
  z-index: 1;
  background: white;
  margin-left: 25%;
  position: absolute;
  margin-top: 10px;
}
.v-dialog > .v-card > .v-card__text {
  padding-top: 5px;
  padding-bottom: 5px;
}
.v-card .v-card__actions {
  padding-top: 5px;
  padding-bottom: 5px;
}
.v-dialog .v-card .v-card__title {
  padding-top: 10px;
}
</style>
